export default function PHP_ftp_nb_fget() {
  return (
    <div>
      <h1>PHP_ftp_nb_fget</h1>
    </div>
  );
}
